import styled, { css } from "styled-components";

export const Container = styled.aside`
  position: absolute;
  width: 250px;
  height: 94vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #fff;
  transition: all 11300ms;

  ${({ informaAcademyCourse }) =>
    informaAcademyCourse &&
    css`
      left: -280px;
      /* width: 0px;
      transform: translateX(-280px); */
    `}

  li {
    width: 250px !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 12px 16px !important;
    gap: 12px;

    span {
      padding: 0 !important;
    }
  }
`;

export const Image = styled.img`
  margin: 0;
  height: 80px;
`;
